module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/osago-desktop-a3f2072537d88011b715523e92c4f671.png";